import React from 'react'
import _get from 'lodash/get'

export const createOrderOptions = count =>
  Array.from({ length: count }, (_, index) => ({
    label: index + 1,
    value: index + 1,
  }))

export const FieldWrapper = ({ children, className, rowClassName = '' }) => {
  const classNames = className || 'col-xs-12 col-sm-6'
  return (
    <div className={`m-15n ${rowClassName}`}>
      {React.Children.map(children, child => (
        <div key={child?.key} className={classNames}>
          {child}
        </div>
      ))}
    </div>
  )
}

export const FIELDS = {
  RADIO: { key: 'radio', optionsKey: 'radioOptions' },
  SELECT: { key: 'select', optionsKey: 'selectOptions' },
  SELECT_MULTI: { key: 'select_multi', optionsKey: 'multiSelectOptions' },
}

export const fieldTypeOptions = [
  { value: 'email', label: 'Email' },
  { value: 'text', label: 'Text' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'radio', label: 'Radio' },
  { value: 'select', label: 'Select' },
  { value: 'select_multi', label: 'Multiple Select' },
]

export const getScrollToValue = errors => {
  let scrollTo = ''
  const slug = _get(errors, 'slug')
  const title = _get(errors, 'title')
  const fields = _get(errors, 'fields')

  if (slug || title) {
    scrollTo = 'scroll-to-top'
  } else if (fields?.length) {
    const index = fields.findIndex(Boolean)
    scrollTo = `scroll-to-field-${index}`
  }

  return scrollTo
}
